import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  connectAuthEmulator,
  getAuth,
} from 'firebase/auth';
import { CONFIG } from '@/config';

// Initialize Firebase
const app = initializeApp(CONFIG.FIREBASE);

initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Local runs only: sign in against the Firebase Auth emulator, as the local API verifies against it.
const authEmulatorHost = import.meta.env.MAN_VITE_FIREBASE_AUTH_EMULATOR_HOST;
if (authEmulatorHost)
  connectAuthEmulator(auth, `http://${authEmulatorHost}`, { disableWarnings: true });

export default app;
